<template>
  <div v-if="personDeviceIdentityData">
    <div class="row">
      <h3 class="card-title" style="text-decoration:underline;">
        Ρολόι
      </h3>
      <div class="col-md-12">
        <div class="mb-3">
          <label class="mt-3">Ρολόι Παρουσίας*</label>
          <multiselect required v-model="personDeviceIdentityData.device" track-by="id" label="device_name"
            :options="deviceOptions" :multiple="true"></multiselect>
        </div>
      </div>
      <div class="col-md-4">
        <div class="mt-2">
          <label>Αριθμός Κάρτας*</label>
          <input v-model="currentCardNumber" required type="text" class="form-control"
            placeholder="Αριθμός Κάρτας Χρήστη" />
        </div>
      </div>
    </div>
    <button class="btn btn-primary" @click.prevent="UpdatePersonDeviceIdentity" v-if="!isError">
      Ενημέρωση
    </button>

    <p v-if="errorMsgs" style="color:red">
      <strong>{{ errorMsgs }}</strong>
    </p>
  </div>
</template>

<script>
import session from "../../../../api/session";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
import { eventCreate } from "../../../../eventspy.js";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      deviceIdentityData: [],
      personDeviceIdentityData: [],
      isError: false,
      errorMsgs: "",
      currentCardNumber: "",
    };
  },
  mounted() {
    this.fetchUserDetails();
    // this.fetchDeviceIdentity();
  },
  watch: {
    currentCardNumber(v) {
      if (isNaN(v) || v === "" || v === undefined) {
        this.errorMsgs = "Παρακαλώ εισάγετε μόνο αριθμούς";
        this.isError = true;
      } else {
        this.errorMsgs = "";
        this.isError = false;
      }
    },
    // personDeviceIdentityData: {
    //   handler(v) {
    //   if (isNaN(v.card_number)) {
    //     this.errorMsgs = "Παρακαλώ εισάγετε μόνο αριθμούς";
    //     this.isError = true;
    //   } else {
    //     this.errorMsgs = "";
    //     this.isError = false;
    //   }
    // },
    //   deep: true,
    // },
  },
  computed: {
    ...mapState("utils", ["devices"]),
    deviceOptions() {
      return this.devices.map((e) => {
        return {
          id: e.id,
          device_name: e.device_name,
        };
      });
    },
  },
  methods: {
    cardNumberExistsBeforeUpdate(cardNumber) {
      const response = session.get(
        `api/device-identities/?card_number=${cardNumber}`
      );
      return response;
    },
    async fetchUserDetails() {
      await session
        .get(`api/user/${this.$route.params.id}`)
        .then((resp) => {
          if (Object.keys(resp.data.person_device_identity).length > 0) {
            this.deviceIdentityData = resp.data.person_device_identity;
            this.fetchDeviceIdentity();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async fetchDeviceIdentity() {
      await session
        .get(`api/device-identity/${this.deviceIdentityData.id}/update/`)
        .then((resp) => {
          this.personDeviceIdentityData = resp.data;
          this.currentCardNumber = resp.data.card_number;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    createDeviceIdentity() {
      const data = {
        person: this.$route.params.id,
        card_number: this.currentCardNumber,
        device: this.deviceOptions.map((e) => e.id),
      };
      session
        .post("api/device-identity/create/", data)
        .then((resp) => {
          this.$toastr.Add({
            name: "UniqueToastName",
            title: `Ενημέρωση`,
            msg:
              "Τα στοιχεία <u>Ρολόι</u>  ανανεώθηκαν επιτυχώς! Γίνεται ενημέρωση στα ρολόγια.",
            style: { backgroundColor: "#4fd69c", width: "550px" },
            progressbar: false,
            timeout: 3501,
          });

          eventCreate(
            `Δημικουργία Στοιχεία ρολογιού :
            useform = ${JSON.stringify(resp.data)}
             `,
            1
          );
          this.fetchUserDetails();
        })
        .catch((e) => {
          console.log(e);
          this.$toastr.e(
            "Οπς! Κατι πήγε στραβά, παρακαλώ επικοινωνήστε με τους διαχειριστές"
          );
        });
    },

    UpdatePersonDeviceIdentity() {
      if (
        this.personDeviceIdentityData &&
        this.personDeviceIdentityData.card_number
      ) {
        if (
          this.currentCardNumber != this.personDeviceIdentityData.card_number
        ) {
          console.log(this.currentCardNumber);
          session
            .get(`api/device-identities/?card_number=${this.currentCardNumber}`)
            .then((resp) => {
              if (resp.data.length > 0) {
                this.$toastr.e("Ο αριθμός κάρτας ανήκει σε άλλον χρήστη");
                return;
              } else {
                const data = {
                  ...this.personDeviceIdentityData,
                  card_number: this.currentCardNumber,
                };
                session
                  .put(
                    `api/device-identity/${this.deviceIdentityData.id}/update/`,
                    data
                  )
                  .then((resp) => {
                    this.$toastr.Add({
                      name: "UniqueToastName",
                      title: `Ενημέρωση`,
                      msg:
                        "Τα στοιχεία <u>Ρολόι</u>  ανανεώθηκαν επιτυχώς! Γίνεται ενημέρωση στα ρολόγια.",
                      style: { backgroundColor: "#4fd69c", width: "550px" },
                      progressbar: false,
                      timeout: 3501,
                    });

                    eventCreate(
                      `Επεξεργασία Στοιχεία ρολογιού :
                      old =  ${JSON.stringify(this.deviceIdentityData)}
                      ---------------------------------
                      useform = ${JSON.stringify(resp.data)}
                     `,
                      2
                    );
                    this.fetchUserDetails();
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              }
            });
          return;
        }
      } else {
        this.createDeviceIdentity();
      }
    },
  },
};
</script>
